import React, { Fragment } from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { IShift } from './interfaces';
import { formatTimeRange } from '@helpers/dateHelpers';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { MemberAvatarAndName } from '@components/MemberAvatarAndName';
import { InfoLine } from './components/InfoLine';
import LockIcon from '@mui/icons-material/Lock';

export const Shift: React.FC<IShift> = ({
  name,
  from,
  to,
  color,
  assignedMember,
  locked = false,
  lockedInfo,
}): JSX.Element => {
  return (
    <Box
      sx={{
        borderRadius: '5px',
        position: 'relative',
        background: '#FFF',
        p: '10px 10px 10px 15px',
        '&:before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '5px',
          backgroundColor: color,
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
      }}
    >
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between">
        <Typography fontWeight="bold" color="text.primary">
          {name}
        </Typography>
        <Stack direction="row" alignItems="center" gap="3px">
          <AccessTimeIcon
            sx={{
              width: '16px',
              height: '16px',
              color: '#95a5a6',
            }}
          />
          <Typography fontWeight="bold" color="text.secondary" variant="body2">
            {formatTimeRange(from, to)}
          </Typography>
        </Stack>
      </Stack>

      {/* BODY */}
      <Stack>
        {lockedInfo && <InfoLine icon={LockIcon} text={lockedInfo} />}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            mt: '10px',
          }}
        >
          {assignedMember ? (
            <MemberAvatarAndName
              slug={assignedMember.slug}
              name={assignedMember.name}
            />
          ) : (
            <Fragment>
              <Chip label="Deze dienst is nog vrij" color="light" />
              <Button variant="contained" size="small" disabled={locked}>
                Deze dienst oppakken
              </Button>
            </Fragment>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
